/** Settings → Nextcloud, where a link is made, mended or undone. */
export const SETTINGS_PATH = '/settings/nextcloud';
